export function CollectionRankingTag({ position }: { position: number | null }) {
  if (!position) return null;

  return (
    <div className="mt-2 flex min-w-0">
      <span className="inline-flex min-w-12 items-center justify-center rounded-lg bg-primary/15 px-3 py-1 text-xl font-black tabular-nums text-primary">
        #{position}
      </span>
    </div>
  );
}
